"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "calvi-risorta": {
    "f5ff89d3": [{
      "hkey": "04ea30d0",
      "slug": "calvi-risorta",
      "name": "Calvi Risorta",
      "primary": true,
      "skipSearch": false
    }],
    "calvi-vecchia": [{
      "hkey": "04ea30d0",
      "slug": "calvi-risorta",
      "name": "Calvi Risorta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b4bf3105": [{
      "hkey": "04ea30d0",
      "slug": "calvi-risorta",
      "name": "Calvi Risorta",
      "primary": true,
      "skipSearch": false
    }],
    "petrulo": [{
      "hkey": "04ea30d0",
      "slug": "calvi-risorta",
      "name": "Calvi Risorta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2a494199": [{
      "hkey": "04ea30d0",
      "slug": "calvi-risorta",
      "name": "Calvi Risorta",
      "primary": true,
      "skipSearch": false
    }],
    "visciano-zuni": [{
      "hkey": "04ea30d0",
      "slug": "calvi-risorta",
      "name": "Calvi Risorta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;